module.exports = __webpack_public_path__ + "img/switch-browser@2x.62c16c45.png";